import { ButtonPrimary, StepIndicator, typographyRem } from '@by-miles/bymiles-styles'
import React, { useContext } from 'react'

import { AccessibleFormWrapper } from '../components/AccessibleFormWrapper'
import LoadingMask from '../components/LoadingMask'
import { AdditionalDrivers } from '../components/QuoteFlow/Driver/AdditionalDrivers'
import { DriverClaims } from '../components/QuoteFlow/Driver/DriverClaims'
import { DriverContactDetails } from '../components/QuoteFlow/Driver/DriverContactDetails'
import { DriverConvictions } from '../components/QuoteFlow/Driver/DriverConvictions'
import { DriverDriving } from '../components/QuoteFlow/Driver/DriverDriving'
import { DriverHomeAddress } from '../components/QuoteFlow/Driver/DriverHomeAddress'
import { DriverMedical } from '../components/QuoteFlow/Driver/DriverMedical'
import { DriverName } from '../components/QuoteFlow/Driver/DriverName'
import { DriverPersonalInfo } from '../components/QuoteFlow/Driver/DriverPersonalInfo'
import { DriversTabGroup } from '../components/QuoteFlow/Driver/DriversTabGroup'
import { DriverYourEmployment } from '../components/QuoteFlow/Driver/YourEmployment'
import { BasePage, BasePageProps } from '../HOCs/BasePage'
import { ProviderContext } from '../Provider'
import { quoteSteps } from '../utils/steps'
import { useDriverPageContext } from './DriverPageProvider'
import { EntryStepsStyles } from './styles/EntryStepsStyles'
const { hero: Hero } = typographyRem

const Driver = ({ quote }: BasePageProps) => {
  const {
    state: { showModal, selectedDriverIndex, isFetching },
  } = useContext(ProviderContext)
  const { validateAndSave, lastDriver } = useDriverPageContext()

  return (
    <EntryStepsStyles>
      {isFetching && <LoadingMask />}
      <StepIndicator
        validateOnClick={(step: string) => validateAndSave(step)}
        steps={quoteSteps}
        preFilledStep="driver"
      />
      {!!quote?.details?.additional_drivers?.length && <DriversTabGroup />}
      <Hero>{`Tell us about ${!selectedDriverIndex ? 'yourself' : 'your other driver'}.`}</Hero>
      <div className="entry-step-component-wrapper">
        <AccessibleFormWrapper onSubmit={validateAndSave}>
          <DriverName />
          <DriverPersonalInfo />
          {!selectedDriverIndex && (
            <>
              <DriverHomeAddress />
              <DriverContactDetails />
            </>
          )}
          <DriverYourEmployment />
        </AccessibleFormWrapper>
        <DriverDriving />
        <AccessibleFormWrapper onSubmit={validateAndSave}>
          <DriverMedical />
        </AccessibleFormWrapper>
        <DriverClaims />
        <DriverConvictions />
        <AdditionalDrivers />
        <ButtonPrimary
          label={`Continue / ${lastDriver ? 'Cover' : 'Next driver'}`}
          iconRight="IconArrowRight"
          onClick={() => validateAndSave()}
          shadow
          dataCy="continue-cover-button"
          className="continue-button"
          tabFocusTrap={showModal ? -1 : 0}
        />
      </div>
    </EntryStepsStyles>
  )
}

export default BasePage(Driver)
